import { ActionIcon, Flex, FlexProps, Text } from '@mantine/core';
import { ReactNode } from 'react';
import { PiPencil } from 'react-icons/pi';

import classes from './EntityListItem.module.css';

export default function EntityListItem({
  topRow,
  bottomRow,
  selected,
  ...props
}: FlexProps & {
  selected?: boolean;
  topRow: ReactNode | string;
  bottomRow?: ReactNode | string;
}) {
  return (
    <Flex
      className={`${classes.item} ${selected ? classes.selected : ''}`}
      {...props}
    >
      <Flex flex={1} direction={'column'}>
        <Flex>
          {typeof topRow === 'string' ? (
            <Text fz={'sm'} fw={500}>
              {topRow}
            </Text>
          ) : (
            topRow
          )}
        </Flex>
        <Flex align={'center'} gap={'lg'}>
          {bottomRow && typeof bottomRow === 'string' ? (
            <Text fz={'xs'}>{bottomRow}</Text>
          ) : (
            bottomRow
          )}
        </Flex>
      </Flex>
      <Flex>
        <ActionIcon variant="light">
          <PiPencil />
        </ActionIcon>
      </Flex>
    </Flex>
  );
}
